(function () {
  if (document.body.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    if (!window.gsap || !window.ScrollTrigger) {
      setTimeout(init, 50);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Horizon usa `.page-wrapper` como contenedor real de scroll en desktop
    // (≥990px, layout "squeeze" para los drawers) y el scroll nativo del
    // documento en mobile — ver assets/scroll-container.js. ScrollTrigger
    // mide contra `window` por defecto, así que si no le indicamos el
    // contenedor real, el progreso de scroll (scrub, parallax) nunca se
    // calcula bien en desktop.
    var isSqueezeLayout = window.matchMedia('(min-width: 990px)').matches;
    var scroller = isSqueezeLayout
      ? (document.querySelector('.page-wrapper') || document.scrollingElement)
      : document.scrollingElement;
    ScrollTrigger.defaults({ scroller: scroller });

    const ease = 'expo.out';

    // Tweens "reveal" (from opacity:0) disparados por ScrollTrigger. Se
    // registran acá para la red de seguridad al final del archivo.
    const revealTweens = [];
    function reveal(targets, vars) {
      vars.scrollTrigger = Object.assign(
        { toggleActions: 'play none none none' },
        vars.scrollTrigger || {}
      );
      const tween = gsap.from(targets, vars);
      revealTweens.push(tween);
      return tween;
    }

    // Nota: el fade-in de entrada del hero (eyebrow, h1, tagline, botones,
    // botella, scrollcue) ya corre en CSS puro (@keyframes pfFadeUp /
    // pfClipReveal, ver parfaria-hero.liquid) — no se duplica acá con GSAP.

    // ── Hero scroll scrub (parallax continuo atado al scroll; no es "reveal") ──
    const heroBottle = document.querySelector('#pfHeroBottle');
    const heroGlow = document.querySelector('.pf-hero__glow');
    const heroCopy = document.querySelector('.pf-hero__left');
    const hero = document.querySelector('#parfaria-hero');

    if (heroBottle && hero) {
      gsap.to(heroBottle, {
        yPercent: -30, scale: 1.15, ease: 'none',
        scrollTrigger: {
          trigger: hero, start: 'top top', end: 'bottom top', scrub: true,
          // La respiración (pf-breathe) y este parallax compiten por
          // `transform` en el mismo elemento — la pausamos mientras el
          // parallax está activo para que no se pisen.
          onToggle: function (self) {
            heroBottle.classList.toggle('pf-parallax-active', self.isActive);
          }
        }
      });
      if (heroGlow) {
        gsap.to(heroGlow, {
          opacity: 0.35, scale: 1.3, ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
        });
      }
      if (heroCopy) {
        gsap.to(heroCopy, {
          opacity: 0, yPercent: -35, ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: '45% top', scrub: true }
        });
      }
    }

    // Nota: el Manifiesto ("No vendemos perfume...") y los pasos del método
    // ("Método") ya se revelan con el sistema data-reveal (CSS +
    // IntersectionObserver) definido en parfaria-hero.liquid. No los
    // animamos acá también: GSAP fija opacity inline (mayor especificidad
    // que la clase .pf-revealed) y si el ScrollTrigger no dispara, el
    // elemento queda invisible para siempre sin que el CSS pueda
    // rescatarlo. Mismo motivo para el título/firma del Cierre más abajo.

    // ── Colecciones: cards fade-up ─────────────────────────────
    const colGrid = document.querySelector('[data-testid="collections-list-grid"]');
    if (colGrid) {
      reveal(colGrid.children, {
        opacity: 0, y: 40, duration: 0.9, stagger: 0.12, ease,
        scrollTrigger: { trigger: colGrid, start: 'top 82%' }
      });
    }

    // ── Combos: cards fade-up ──────────────────────────────────
    const comboGrid = document.querySelectorAll('.product-card');
    if (comboGrid.length) {
      reveal(comboGrid, {
        opacity: 0, y: 40, duration: 0.9, stagger: 0.14, ease,
        scrollTrigger: { trigger: comboGrid[0].closest('section') || comboGrid[0], start: 'top 80%' }
      });
    }

    // ── Testimonios ────────────────────────────────────────────
    const testimonioCards = document.querySelectorAll('.pf-testimonial');
    if (testimonioCards.length) {
      reveal(testimonioCards, {
        opacity: 0, y: 30, duration: 0.9, stagger: 0.16, ease,
        scrollTrigger: { trigger: testimonioCards[0].parentElement, start: 'top 78%' }
      });
    }

    // Nota: el título, CTA y firma del Cierre ya usan data-reveal (ver
    // sections/parfaria-cierre.liquid). No se duplican acá, mismo motivo
    // que en "Método" (ver nota más arriba).

    // ── Generic fade-up para secciones custom-liquid ───────────
    document.querySelectorAll('.pf-fadein').forEach((el) => {
      reveal(el, {
        opacity: 0, y: 30, duration: 1, ease,
        scrollTrigger: { trigger: el, start: 'top 82%' }
      });
    });

    // Recalcular posiciones una vez que todos los triggers están creados
    // y todo el contenido (imágenes, fuentes) terminó de cargar.
    ScrollTrigger.refresh();
    if (document.readyState === 'complete') {
      ScrollTrigger.refresh();
    } else {
      window.addEventListener('load', () => ScrollTrigger.refresh());
    }

    // ── Red de seguridad ─────────────────────────────────────────
    // Si algún ScrollTrigger no disparó (por el motivo que sea, ej. los
    // combos) y su elemento ya está dentro o por encima del viewport,
    // forzamos el tween a su estado final. Nunca debe quedar contenido
    // invisible. Corre en un chequeo periódico + en cada scroll, no una
    // sola vez, porque hay secciones que recién entran en viewport bastante
    // después del load.
    function sweepStuckReveals() {
      var pending = false;
      revealTweens.forEach(function (tween) {
        if (!tween || tween._pfResolved) return;
        var targets = tween.targets();
        var anyInView = targets.some(function (el) {
          return el.getBoundingClientRect().top < window.innerHeight;
        });

        // El ScrollTrigger puede reportar progress:1 desde el vamos si su
        // start/end quedó mal calculado (el bug de Lenis), sin que el tween
        // realmente haya jugado su animación. En ese caso también hay que
        // limpiar el estado inline, no solo cuando detectamos opacity:0.
        if (tween.progress() >= 1) {
          if (anyInView) {
            gsap.set(targets, { clearProps: 'opacity,transform,translate,rotate,scale' });
          }
          tween._pfResolved = true;
          return;
        }

        var stuck = anyInView && targets.some(function (el) {
          return parseFloat(window.getComputedStyle(el).opacity) <= 0.05;
        });
        if (stuck) {
          tween.progress(1);
          // progress(1) a veces deja un residuo de transform (ej. y
          // desplazado) en tweens con stagger. Limpiamos los estilos
          // inline por completo para garantizar que quede exactamente
          // como el resto de los elementos ya revelados.
          gsap.set(targets, { clearProps: 'opacity,transform,translate,rotate,scale' });
          tween._pfResolved = true;
        } else {
          pending = true;
        }
      });
      return pending;
    }

    var sweepStart = Date.now();
    var sweepInterval = setInterval(function () {
      var stillPending = sweepStuckReveals();
      if (!stillPending || Date.now() - sweepStart > 20000) {
        clearInterval(sweepInterval);
      }
    }, 500);

    window.addEventListener('scroll', sweepStuckReveals, { passive: true });
    if (scroller !== document.scrollingElement && scroller !== document.documentElement) {
      scroller.addEventListener('scroll', sweepStuckReveals, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
